// Zinsdelen voor de samenvatting van een herhaling (Frans). Zelfde vorm als recurrenceApp.nl.ts.
// Het lidwoord zit in het rangtelwoord ("le dernier", "l’avant-dernier"): zo klopt de elisie.
export const appRecurrenceFr = {
    once: 'Une seule fois',
    everyDay: 'Tous les jours',
    everyWorkday: 'Tous les jours de semaine',
    everyWeek: 'Chaque semaine',
    everyMonth: 'Chaque mois',
    everyYear: 'Chaque année',
    everyWeekdays: 'Chaque {days}',
    otherDay: 'Un jour sur deux',
    otherWeek: 'Une semaine sur deux',
    otherMonth: 'Un mois sur deux',
    otherYear: 'Un an sur deux',
    nDays: { one: 'Tous les {count} jours', other: 'Tous les {count} jours' },
    nWeeks: { one: 'Toutes les {count} semaines', other: 'Toutes les {count} semaines' },
    nMonths: { one: 'Tous les {count} mois', other: 'Tous les {count} mois' },
    nYears: { one: 'Tous les {count} ans', other: 'Tous les {count} ans' },
    dailyOnlyOn: '{period}, seulement le {days}',
    weeklyOn: '{period}, le {days}',
    weeklyAllDays: '{period}, tous les jours',
    weeklyWorkdays: '{period}, en semaine',
    monthlyOrdinal: '{ordinals} de chaque mois',
    monthlyOrdinalPeriod: '{period}, {ordinals}',
    monthlyOn: '{period}, {days}',
    ifWeekday: '{text}, si c’est un {days}',
    monthDay: 'le {day}',
    lastDay: 'le dernier jour',
    nthLastDay: '{ordinal} jour',
    yearlyOrdinal: '{period}, {ordinals} en {months}',
    yearlyOn: '{period}, le {date}',
    yearlyDays: '{period}, {days} en {months}',
    dayMonth: '{day} {month}',
    ordinalWeekday: '{ordinals} {weekday}',
    anyWeekday: 'chaque {weekday}',
    ord1: 'le premier',
    ord2: 'le deuxième',
    ord3: 'le troisième',
    ord4: 'le quatrième',
    ord5: 'le cinquième',
    ordLast: 'le dernier',
    ordLast2: 'l’avant-dernier',
    ordLast3: 'l’antépénultième',
    ordLast4: 'le quatrième avant la fin',
    ordLast5: 'le cinquième avant la fin',
    ordN: 'le {n}e',
    evenWeeks: '{text} (semaines paires)',
    oddWeeks: '{text} (semaines impaires)',
    at: '{text} à {time}',
    fromTo: '{text} de {start} à {end}',
    times: { one: '{text}, {count} fois', other: '{text}, {count} fois' },
    until: '{text}, jusqu’au {date}',
    listAnd: '{a} et {b}',
    listSep: ', ',
};
//# sourceMappingURL=recurrenceApp.fr.js.map